
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/composers",
      function () {
        return require("private-next-pages/composers/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/composers"])
      });
    }
  